
<ul class="nav nav-tabs">
  <li class="nav-item " *ngFor="let ctrl of tabs"
      [ngClass]="{ 'sel': selectedTab == ctrl.serial,
                   'disabledDiv': ctrl.disabled == true
                 }"
      id="li{{ctrl.serial}}"
      [hidden]="ctrl['visible'] == 0"
   >

    <a class="nav-link active"
       [ngClass]="{ 'active': selectedTab == ctrl.serial,
                    'disabled': ctrl.disabled == true
                  }"
       (click)="tabClicked(ctrl)">
      <span class="innerTextLabel">
            {{prefixLabel}}
            {{translate.currentLang == 'ar'? ctrl.nameAr: ctrl.nameEn}}
      </span>
    </a>
  </li>
</ul>
